import { render, staticRenderFns } from "./EventEditForm.vue?vue&type=template&id=5920e8c4&scoped=true&"
import script from "./EventEditForm.vue?vue&type=script&lang=js&"
export * from "./EventEditForm.vue?vue&type=script&lang=js&"
import style0 from "./EventEditForm.vue?vue&type=style&index=0&id=5920e8c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5920e8c4",
  null
  
)

export default component.exports